import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  noMessage: theme.mixins.gutters({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }),
  container: {
    position: 'relative'
  }
}));

export default useStyles;
